import { useMemo } from 'react';

import { DeliveryProviderService } from '../api/openapi_gen/deliveryProviderPortal/deliveryProvider';

import ProviderSignupSource = DeliveryProviderService.ProviderSignupSource;
import ProviderLifecycleStatus = DeliveryProviderService.ProviderLifecycleStatus;
import { useCommonAppServices } from '../services/ContextProviders';
import { useObservableAndState } from './useObservableAndState';

export const useIsProviderInSSUFlow = () => {
  const { accountService } = useCommonAppServices();
  const selectedProvider = useObservableAndState(accountService.getSelectedProviderData$());
  const accountDetails = useObservableAndState(accountService.getAccountDetails$());

  return useMemo(() => {
    // New Merchant Venue onboarding
    const isNewMerchantVenueInOnboarding =
      selectedProvider.signup_source === ProviderSignupSource.NEW_MERCHANT_VENUE &&
      selectedProvider.lifecycle_status === ProviderLifecycleStatus.ONBOARDING;

    if (isNewMerchantVenueInOnboarding) {
      return true;
    }

    // SSU onboarding
    const isAccountOnboarding = accountDetails?.account_data?.is_account_onboarding ?? false;
    const assignedProviders = accountDetails?.assignments ?? [];
    const isSSUOnboarding = isAccountOnboarding && assignedProviders.length === 1;

    return isSSUOnboarding;
  }, [
    selectedProvider.signup_source,
    selectedProvider.lifecycle_status,
    accountDetails?.account_data?.is_account_onboarding,
    accountDetails?.assignments,
  ]);
};
